// extracted by mini-css-extract-plugin
var _1 = "ProfileWalletInfo_lineContent__txDyJ";
var _2 = "ProfileWalletInfo_lineName__oRDA7";
var _3 = "ProfileWalletInfo_note__2XL0q";
var _4 = "ProfileWalletInfo_profileWalletContainer__MLeeW";
var _5 = "ProfileWalletInfo_profileWalletLine__iX9Gx";
var _6 = "ProfileWalletInfo_wideContent__SOedn";
export { _1 as "lineContent", _2 as "lineName", _3 as "note", _4 as "profileWalletContainer", _5 as "profileWalletLine", _6 as "wideContent" }
